import React, { useState } from 'react';


const salaryRanges = [
  { label: '0-3 Lakhs', min: 0, max: 3 },
  { label: '3-6 Lakhs', min: 3, max: 6 },
  { label: '6-10 Lakhs', min: 6, max: 10 },
  { label: '10-15 Lakhs', min: 10, max: 15 },
  { label: '15-20 Lakhs', min: 15, max: 20 },
  { label: '20-30 Lakhs', min: 20, max: 30 },
  { label: '30-50 Lakhs', min: 30, max: 50 },
  { label: '50-75 Lakhs', min: 50, max: 75 },
];

// Main Component
const JobFilter = ({jobs}) => {
    const [selectedTitles, setSelectedTitles] = useState([]);
    const [selectedExpertise, setSelectedExpertise] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [selectedQualification, setSelectedQualification] = useState([]);
    const [selectedWorkMode, setSelectedWorkMode] = useState([]);
    const [selectedExperience, setSelectedExperience] = useState('');
    const [selectedSalaryRanges, setSelectedSalaryRanges] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [locationInput, setLocationInput] = useState('');

    // Handle filter changes
    const handleTitleChange = (title) => {
        setSelectedTitles((prevTitles) =>
            prevTitles.includes(title)
                ? prevTitles.filter((t) => t !== title)
                : [...prevTitles, title]
        );
    };

    // const handleExpertiseChange = (expertise) => {
    //     setSelectedExpertise((prevExpertise) =>
    //         prevExpertise.includes(expertise)
    //             ? prevExpertise.filter((e) => e !== expertise)
    //             : [...prevExpertise, expertise]
    //     );
    // };

    const handleDepartmentChange = (department) => {
      setSelectedDepartment((prevDepartment) =>
          prevDepartment.includes(department)
              ? prevDepartment.filter((d) => d !== department)
              : [...prevDepartment, department]
      );
  };

    const handleQualificationChange = (qualification) => {
        setSelectedQualification((prevQualification) =>
            prevQualification.includes(qualification)
                ? prevQualification.filter((q) => q !== qualification)
                : [...prevQualification, qualification]
        );
    };

    const handleWorkModeChange = (workMode) => {
        setSelectedWorkMode((prevWorkMode) =>
            prevWorkMode.includes(workMode)
                ? prevWorkMode.filter((w) => w !== workMode)
                : [...prevWorkMode, workMode]
        );
    };

    const handleSalaryRangeChange = (range) => {
      setSelectedSalaryRanges((prevRanges) =>
          prevRanges.includes(range)
              ? prevRanges.filter((r) => r !== range)
              : [...prevRanges, range]
      );
  };

    // Filter jobs based on selected criteria
    const filteredJobs = jobs.filter((job) => {
        const matchesTitle = selectedTitles.length === 0 || selectedTitles.includes(job.title);
        const matchesDepartment = selectedDepartment.length === 0 || selectedDepartment.includes(job.department);

        const matchesQualification = selectedQualification.length === 0 || selectedQualification.includes(job.qualification);
        const matchesExperience = !selectedExperience || job.experience === parseInt(selectedExperience, 10);
        const matchesSalary =
            selectedSalaryRanges.length === 0 ||
            selectedSalaryRanges.some(
                (range) => job.salary >= range.min && job.salary <= range.max
            );


        const matchesSearch =
            searchText === '' ||
            job.title?.toLowerCase().includes(searchText.toLowerCase()) ||
            job.company?.toLowerCase().includes(searchText.toLowerCase()) ||
            (Array.isArray(job.expertise) &&
                job.expertise.some((skill) => skill?.toLowerCase().includes(searchText.toLowerCase())));
        const matchesLocation =
            locationInput === '' || job.location?.toLowerCase().includes(locationInput.toLowerCase());
        const matchesWorkMode = selectedWorkMode.length === 0 || selectedWorkMode.includes(job.workMode);

        return matchesTitle && matchesDepartment && matchesQualification && matchesExperience && matchesSalary && matchesSearch && matchesLocation && matchesWorkMode;
    });

    return (
        <div className="px-12 flex flex-row gap-8 justify-center mt-10 mb-20 max-h-[175vh]">
            <div className="w-1/4 bg-gray-100 px-10 h-fit pt-8">
                <h2 className="font-bold mb-4">Job Availability</h2>

                {/* Work Mode Filter */}
                <div className="mb-6">
                    <h2 className="font-bold">Work Mode</h2>
                    <div className="flex flex-col flex-wrap gap-2 text-[#0077af]">
                        {['Work From Home', 'Hybrid', 'Remote'].map((workMode) => (
                            <label key={workMode} className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    value={workMode}
                                    onChange={() => handleWorkModeChange(workMode)}
                                    checked={selectedWorkMode.includes(workMode)}
                                />
                                <span>{workMode}</span>
                            </label>
                        ))}
                    </div>
                </div>

                {/* Experience Filter */}
                <div className="mb-8">
                    <h2 className="font-bold">Experience</h2>
                    <select
                        className="border p-2 w-full"
                        value={selectedExperience}
                        onChange={(e) => setSelectedExperience(e.target.value)}
                    >
                        <option value="">Select Experience</option>
                        {[1, 2, 3, 4, 5, 6].map((experience) => (
                            <option key={experience} value={experience}>
                                {experience} Years
                            </option>
                        ))}
                    </select>
                </div>


                {/* Job Titles Filter */}
                <div className="mb-4">
                    <h2 className="font-bold">Role Category</h2>
                    <div className="flex flex-col flex-wrap gap-2 text-[#0077af]">
                        {['Software Engineer', 'Frontend Developer', 'Backend Developer', 'Business Analyst', 'Full-Stack Developer', 'Designer', 'HR', 'Other'].map((title) => (
                            <label key={title} className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    value={title}
                                    onChange={() => handleTitleChange(title)}
                                    checked={selectedTitles.includes(title)}
                                />
                                <span>{title}</span>
                            </label>
                        ))}
                    </div>
                </div>
                  
                  {/* Salary Range Filter */}
                <div className="mb-4">
                    <h2 className="font-bold">Salary</h2>
                    <div className="flex flex-col flex-wrap gap-2 text-[#0077af]">
                        {salaryRanges.map((range) => (
                            <label key={range.label} className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    value={range.label}
                                    onChange={() => handleSalaryRangeChange(range)}
                                    checked={selectedSalaryRanges.includes(range)}
                                />
                                <span>{range.label}</span>
                            </label>
                        ))}
                    </div>
                </div>

                {/* Expertise Filter */}
                {/* <div className="mb-4">
                    <h2 className="font-bold">Expertise</h2>
                    <div className="flex flex-col flex-wrap gap-2 text-[#0077af]">
                        {['Java', 'React', 'Python', 'Business', 'Figma', 'HTML', 'Javascript', 'Canva'].map((expertise) => (
                            <label key={expertise} className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    value={expertise}
                                    onChange={() => handleExpertiseChange(expertise)}
                                    checked={selectedExpertise.includes(expertise)}
                                />
                                <span>{expertise}</span>
                            </label>
                        ))}
                    </div>
                </div> */}

                {/* Department Filter */}
                <div className="mb-4">
                    <h2 className="font-bold">Filter by Department</h2>
                    <div className="flex flex-col flex-wrap gap-2 text-[#0077af]">
                        {['Engineering', 'Business Development', 'Human Resources'].map((department) => (
                            <label key={department} className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    value={department}
                                    onChange={() => handleDepartmentChange(department)}
                                    checked={selectedDepartment.includes(department)}
                                />
                                <span>{department}</span>
                            </label>
                        ))}
                    </div>
                </div>
                
                {/* Qualification Filter */}
                <div className="mb-4">
                    <h2 className="font-bold">Qualification</h2>
                    <div className="flex flex-col flex-wrap gap-2 text-[#0077af]">
                        {['B.Tech', 'M.Tech', 'PhD', 'Graduate', 'Postgraduate', 'MBA', 'Other'].map((qualification) => (
                            <label key={qualification} className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    value={qualification}
                                    onChange={() => handleQualificationChange(qualification)}
                                    checked={selectedQualification.includes(qualification)}
                                />
                                <span>{qualification}</span>
                            </label>
                        ))}
                    </div>
                </div>

                
            </div>

            {/* Filtered Job Cards */}
            <div className="w-2/4 flex flex-col gap-8 overflow-y-auto">
                {/* Search Bar */}
                <div className="flex items-center mb-4">
                    <input
                        type="text"
                        placeholder="Search by title, company, or skill"
                        className="border p-2 w-1/2 mr-4"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Enter location"
                        className="border p-2 w-1/4 mr-4"
                        value={locationInput}
                        onChange={(e) => setLocationInput(e.target.value)}
                    />
                    <button className="bg-[#0077af] text-white px-4 py-2">Search</button>
                </div>
                {filteredJobs.length > 0 ? (
                    filteredJobs.map((job) => (
                        <div key={job.id} className="border p-4 rounded bg-gray-100">
                            <h3 className="font-bold text-xl pb-4 text-[#0077af] gap-5">{job.title}</h3>
                            <p className="font-medium">
                                <span className="text-base font-semibold">Company:</span> {job.company}
                            </p>
                            <p className="font-medium">
                                <span className="text-base font-semibold">Experience:</span> {job.experience} Years
                            </p>
                            <p className="font-medium">
                                <span className="text-base font-semibold">Location:</span> {job.location}
                            </p>
                            <p className="font-medium">
                                <span className="text-base font-semibold">Mode:</span> {job.workMode}
                            </p>
                            <p className="font-medium">
                                <span className="text-base font-semibold">Skills:</span> {job.expertise.join(', ')}
                            </p>
                            <p className="font-medium">
                                <span className="text-base font-semibold">Salary:</span> ₹{job.salary} LPA
                            </p>
                        </div>
                    ))
                ) : (
                    <p>No jobs found</p>
                )}
            </div>
        </div>
    );
};

export default JobFilter;
